import React, { Fragment, memo, useCallback, useMemo, useRef, useState } from 'react';

import { publish } from 'lib/EventBuser';
import { VALUELIST_REFRESH } from 'lib/events';

import ValueListList from './ValueListList';
import FormValueList from './FormValueList/index';

const ValueLists = ({ timeZone, onUpdate, overrides, productCode }) => {
    const form = useRef();
    const [activeRowId, setActiveRowId] = useState(null);
    const tracking = overrides?.tracking;

    const onCreate = useCallback(() => {
        form.current.open({});
        onUpdate && onUpdate();
        tracking?.create && tracking.create();
    }, [onUpdate, tracking]);

    const onEdit = useCallback(
        (row) => {
            if (row.isView) return;
            setActiveRowId(row.id);
            form.current.open({ id: row.id, isEditable: row.canEdit });
            tracking?.update && tracking.update();
        },
        [tracking],
    );

    const onDuplicate = useCallback(
        (row) => {
            form.current.open({ id: row.id, isForDuplicate: true, isEditable: row.canEdit });
            onUpdate && onUpdate();
        },
        [onUpdate],
    );

    const refreshList = useCallback(() => publish(VALUELIST_REFRESH), []);

    const finalOverrides = useMemo(
        () => ({ ...overrides, columnsToHide: overrides?.valueListColumnsToHide || [] }),
        [overrides],
    );

    const isSage = useMemo(() => productCode?.toLowerCase()?.includes('sage'), [productCode]);

    return (
        <Fragment>
            <ValueListList
                activeRowId={activeRowId}
                setActiveRowId={setActiveRowId}
                onCreate={onCreate}
                onEdit={onEdit}
                onDuplicate={onDuplicate}
                overrides={overrides}
            />
            <FormValueList
                setActiveRowId={setActiveRowId}
                onRef={(ref) => (form.current = ref)}
                refreshList={refreshList}
                timeZone={timeZone}
                overrides={finalOverrides}
                onUpdate={onUpdate}
                isSage={isSage}
            />
        </Fragment>
    );
};

ValueLists.propTypes = {};

export default memo(ValueLists);
